import { render, staticRenderFns } from "./Nav.vue?vue&type=template&id=8a6c6b2c&"
import script from "./Nav.vue?vue&type=script&lang=js&"
export * from "./Nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/kunst.dk/http/public/typo3conf/ext/kunst_design/Resources/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('8a6c6b2c', component.options)
    } else {
      api.reload('8a6c6b2c', component.options)
    }
    module.hot.accept("./Nav.vue?vue&type=template&id=8a6c6b2c&", function () {
      api.rerender('8a6c6b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Private/modernjs/nav/Nav.vue"
export default component.exports